import { render, staticRenderFns } from "./BlackGoldSiteFooter.vue?vue&type=template&id=db162b34"
import script from "./BlackGoldSiteFooter.vue?vue&type=script&lang=js"
export * from "./BlackGoldSiteFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports